import type { LookoRouteObject } from '../LookoRouteObject';
import 업로드_설정_라우터 from './upload';

// 설정 메뉴 전체
const 설정_메뉴_라우터: LookoRouteObject[] = [...업로드_설정_라우터];

export default 설정_메뉴_라우터;
